import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { sanityImageUrl, priceValues } from './helpers'
import ProductSchema from '../components/Shared/Schema/Product'
import FaqSchema from '../components/Shared/Schema/Faq'

const isProd = process.env.NODE_ENV === 'production'
const branchName = process.env.BRANCH

const Seo = ({ location, pageContext, noIndexStatic, themeColor = '#000000' }) => {
  const { site } = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
          twitterUsername
        }
      }
    }
  `)

  const {
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    siteUrl,
    twitterUsername,
  } = site.siteMetadata
  
  const {
    title: pageTitle,
    description: pageDescription,
    image: pageImage,
    noIndex,
    canonicalUrl,
  } = pageContext?.post?.seo || pageContext?.data?.seo || {}

  const title = pageTitle || defaultTitle
  const description = pageDescription || defaultDescription
  const image = sanityImageUrl(pageImage) || defaultImage
  const pageUrl = siteUrl + (location.pathname === '/' ? '' : location.pathname)
  const canonical = canonicalUrl ? siteUrl + canonicalUrl : pageUrl

  const productData = pageContext?.data?.protocolRef
  const productsData = pageContext?.data?.protocolRefs

  const reviewsHide = !!pageContext?.data?.reviews?.isHide
  const reviewsData = reviewsHide ? false : pageContext?.data?.reviews?.reviewList || pageContext?.data?.reviews

  const faqHidden = !!pageContext?.data?.faq?.isHide
  const faqData = faqHidden ? false : pageContext?.data?.faq?.faqList || pageContext?.data?.faq

  const prices = priceValues(pageContext.data?.prices)
  
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />

      <link rel="canonical" href={canonical} />

      <meta name="theme-color" content={themeColor} />
      <meta name="facebook-domain-verification" content="iya5akpfz91rabm8tmn69esd7mz8vi" />
      <meta name="google-site-verification" content="CGren4xLhQQQSz6eDZ0YcVtnBFR_Xw1xiKgfwDNVbTY" />

      <meta name="og:type" content="website" />
      <meta name="og:title" content={title} />
      <meta name="og:url" content={pageUrl} />
      <meta name="og:description" content={description} />
      <meta name="og:image" content={image} />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:url" content={pageUrl} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content={twitterUsername} />

      <script referrerPolicy="origin" src="https://e9f88c394b3d4e559ac686e16513ef38.js.ubembed.com" async></script>

      {(noIndex || noIndexStatic) && <meta name="robots" content="noindex" />}

      {productData && <ProductSchema price={prices[productData.priceTag]} product={productData} reviews={reviewsData} />}
      {productsData && productsData.map(data => <ProductSchema price={prices[data.priceTag]} product={data} reviews={reviewsData} />)}
      {faqData && <FaqSchema faq={faqData} />}

      {isProd && (
        <>
          <script
            type="text/javascript"
            src="https://cdn.amplitude.com/script/1383a0c7c8681f872dca9e3b450439f5.experiment.js"
          />
          <script type="text/javascript">
            {`
              window.analytics.track('segmentUserIdentify', { user_id: '', email_hash: '' });
              window.analytics.track('pageview', {
                'Branch': '${branchName}'
              });
            `}
          </script>
        </>
      )}
    </>
  )
}

export default Seo
